jQuery(document).ready(function () {
    $(document).on('click', '.dnFormInputFileImagePreview-image-container', function (e) {
        var button = $(this);
        var containerClass = button.attr('data-trigger-class');
        var container = button.parent('.dnFormInputFileImagePreview-container').find('input[type=file]' + containerClass);

        var containerCheckbox = button.parent('.dnFormInputFileImagePreview-container').find('input[type=checkbox]' + containerClass);

        container.click();

        if (containerCheckbox.is(':checked')) {
            containerCheckbox.click();
        }
    });

    $(document).on('click', '.dnFormInputFileImagePreview-image-delete', function (e) {
        var button = $(this);
        var containerClass = button.attr('data-trigger-class');
        var deleteConfirmText = button.attr('data-delete-confirm');
        var container = button.parent('.dnFormInputFileImagePreview-container').find('input[type=checkbox]' + containerClass);

        if (!container.is(':checked')) {
            if (!confirm(deleteConfirmText)) {
                return false;
            }
        }

        container.click();
    });


    $(document).on('dragenter', '.dnFormInputFileImagePreview-image-container', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var button = $(this);
        var container = button.parent('.dnFormInputFileImagePreview-container');
        container.addClass('dnFormInputFileImagePreview-container-isDrag');
    });

    $(document).on('dragover', '.dnFormInputFileImagePreview-image-container', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.originalEvent.dataTransfer.dropEffect = 'copy';
    });

    $(document).on('dragleave', '.dnFormInputFileImagePreview-image-container', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var button = $(this);
        var container = button.parent('.dnFormInputFileImagePreview-container');
        container.removeClass('dnFormInputFileImagePreview-container-isDrag');
    });

    $(document).on('drop', '.dnFormInputFileImagePreview-image-container', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var button = $(this);
        var containerClass = button.attr('data-trigger-class');
        var container = button.parent('.dnFormInputFileImagePreview-container');
        var containerInput = container.find('input[type=file]' + containerClass);

        var fileCountErrorText = button.attr('data-error-filecount');

        var files = e.originalEvent.dataTransfer.files;

        if (files.length != 1) {
            alert(fileCountErrorText);
        } else {
            containerInput.prop('files', files);

            containerInput.trigger('change');
        }

        container.removeClass('dnFormInputFileImagePreview-container-isDrag');
    });


    $(document).on('change', '.dnFormInputFileImagePreview-trigger', function (e) {
        var trigger = $(this);
        var container = trigger.parents('.dnFormInputFileImagePreview-container');

        if (this.files !== 'undefined' && typeof FileReader !== 'undefined' && trigger.attr('type') == 'file') {
            var file = e.target.files[0];
            var fileUploadMaxSize = 2 * 1024 * 1024;

            var imageContainer = container.find('.dnFormInputFileImagePreview-image-container');
            var fileSizeErrorText = imageContainer.attr('data-error-filesize');
            var fileTypeErrorText = imageContainer.attr('data-error-filetype');

            var preview = container.find('.dnFormInputFileImagePreview-image');
            var previewBackground = container.find('.dnFormInputFileImagePreview-image-background');

            if (!/image\/(jpeg|jpg|png)/.test(file.type)) {
                alert(fileTypeErrorText);
            } else if (file.size > fileUploadMaxSize) {
                alert(fileSizeErrorText);
            } else {
                var reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function (e) {
                    container.addClass('dnFormInputFileImagePreview-container-unsaved');
                    container.removeClass('dnFormInputFileImagePreview-container-isNew');
                    preview.attr('src', e.target.result);
                    previewBackground.attr('src', e.target.result);
                };
            }
        } else if (trigger.attr('type') == 'checkbox') {
            if (trigger.is(':checked')) {
                container.addClass('dnFormInputFileImagePreview-container-unsaved');
                container.addClass('dnFormInputFileImagePreview-container-isNew');
            } else {
                container.removeClass('dnFormInputFileImagePreview-container-unsaved');
            }
        }
    });
});